export default __webpack_public_path__ + "media/images/landlords_page/hero-lg-54334b50cdd4b5afd1483ea6d132c328.webp";